"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = void 0;
const config = {
    services: {
        gatekeeper: {
            url: 'https://demo-api.lwtears.com/gatekeeper'
        },
        core: {
            url: 'https://demo-api.lwtears.com/core'
        },
        loginApp: {
            url: 'https://demo-student-login.lwtears.com/login'
        },
        userLogin: {
            url: 'https://demo-www.lwtears.com'
        },
        support: {
            url: 'https://dev.lwtears.com/contact-us/digital-product-support'
        }
    },
    supportEmail: 'technology@lwtears.com'
};
const getConfig = () => config;
exports.getConfig = getConfig;
